


























































import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { EstadoClinicoDTO, EstadoClinicoParm } from '@/interfaces/clinic-states';
import * as service from '@/services/clinic-states';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import ListMessages from '../UI/list-messages.vue';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
  },
})
export default class ClinicStateForm extends BaseComponent {
  @Prop()
  public isEdit: boolean;
  @Prop()
  public id: number;
  @Prop()
  public open: boolean;

  private loading: boolean = false;
  private error: boolean = false;

  public dto: EstadoClinicoParm = new EstadoClinicoParm();

  public form: any = {
    valid: false,
    rules: {
      nome: [(v) => !!v || 'Informe o Nome'],
      ativo: [(v) => v != null || 'Informe o Status'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  @Watch('open')
  public watchOpen(): void {
    setTimeout(() => {
      if (this.open) {
        this.init();
      }
    }, 300);
  }

  public init(): void {
    if (!this.id || this.loading) {
      return;
    }
    this.loading = true;
    this.error = false;
    this.addSubsc(
      service.getClinicState(this.id).subscribe(
        (result) => {
          this.dto = result;
          this.loading = false;
        },
        (error) => {
          this.error = true;
          this.loading = false;
        },
      ),
    );
  }

  public saveItem(): void {
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando ...');
    let parm = new EstadoClinicoParm();
    parm.id = this.dto.id;
    parm.nome = this.dto.nome;
    parm.descricao = this.dto.descricao;
    parm.ativo = this.dto.ativo;
    this.addSubsc(
      service.saveClinicState(parm).subscribe(
        (result) => {
          this.resetForm();
          this.loader.stop();
          this.toast.show('Estado Clínico salvo com sucesso', 'success');
          this.$emit('save');
        },
        (error) => {
          this.loader.stop();
          this.showToastApiError(error);
        },
      ),
    );
  }

  public resetForm(): void {
    this.dto = new EstadoClinicoDTO();
    this.$refs.form.resetValidation();
  }

  private closeAction() {
    this.resetForm();
    this.$emit('close');
  }

  public closeForm(): void {
    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      this.closeAction,
    );
  }
}
